
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderGiftCardsDialog extends Serenity.EntityDialog<OrderGiftCardsRow, any> {
        protected getFormKey() { return OrderGiftCardsForm.formKey; }
        protected getIdProperty() { return OrderGiftCardsRow.idProperty; }
        protected getLocalTextPrefix() { return OrderGiftCardsRow.localTextPrefix; }
        protected getNameProperty() { return OrderGiftCardsRow.nameProperty; }
        protected getService() { return OrderGiftCardsService.baseUrl; }
        protected getDeletePermission() { return OrderGiftCardsRow.deletePermission; }
        protected getInsertPermission() { return OrderGiftCardsRow.insertPermission; }
        protected getUpdatePermission() { return OrderGiftCardsRow.updatePermission; }

        protected form = new OrderGiftCardsForm(this.idPrefix);

    }
}